<template>
    <div class="container-operators-box">
        <div class="container-operators-box-header">
            <div class="title">
                Cadastre caixas e seus respectivos operadores para registro de entrada.
            </div>
        </div>

        <div class="container-operators-box-user-name-box">
            <ui-select-v2
                v-model="form.user_id"
                :data="users"
                :loading="loader.users"
                design="mgb-15 br-all"
                item-label="first_name"
                return-value="id"
                label="Usuário:"
                type="text"
                required
            />

            <ui-input
                v-model="form.name"
                label="Nome da Caixa:"
                placeholder="Digite..."
                type="text"
                required
            />

            <div class="user-name-box-button">
                <ui-engine
                    :data="form"
                    :disabled="!canAdd"
                    url="boxes"
                    design="md primary text-button"
                    service="launchDay"
                    method="create"
                    @input="loadData"
                />
            </div>
        </div>

        <div class="container-operators-box-table">
            <div class="operators-box-table">
                <table-operators-box :contents="data" />
            </div>
        </div>

        <div class="container-operators-box-footer">
            <ui-engine :next="next" :disabled="!$mx_hasValue(data)" name-button="Avançar" />
        </div>
    </div>
</template>

<script>
	import { uiInput, uiSelectV2 } from '@/components/ui/form'
	import { launchDay, user } from '@/services/axios'
	import tableOperatorsBox from './table-operators-box'
	import uiEngine from '../engine'

	import { utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-launch-operators-box',

		components: {
			uiInput,
			uiSelectV2,
			uiEngine,
			tableOperatorsBox
		},

		mixins: [utilMixin],

		data() {
			return {
				data: [],
				users: [],
				next: { name: 'launch.management.create.paymentMethods', index: 2 },
				form: {
					name: '',
					user_id: null,
					launchday_id: null,
				},
				loader: {
					users: false
				}
			}
		},

		computed: {
			...mapGetters('launchDay', { config: 'getConfig' }),
			/**
			 * Computed property que define se o cadastro do operador de caixa pode continuar
			 */
			canAdd() {
				return this.$mx_hasValue(this.form.launchday_id) &&
					this.$mx_hasValue(this.form.name) &&
					this.$mx_hasValue(this.form.user_id)
			}
		},

		created() {
			this.$root.$on('modal-msg-launch-box-method-delete-response',() => {
				this.loadData()
			})
		},

		mounted() {
			this.setPreLoad(true)
			this.loader.users = true
			user.getAll('filter', { groups: 'admin', per_page: 99999 })
				.then(response => {
					this.users = [...response.data.data]
				})
				.catch(error => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				})
				.finally(() => {
					this.loader.users = false
					this.setPreLoad(false)
				})

			this.loadData()
		},

		beforeDestroy() {
			this.$root.$off('modal-msg-launch-box-method-delete-response')
		},

		methods: {
			...mapActions('launchDay', ['setPreLoad', 'setNextLoad']),
			/**
			 * Carrega os dados do lançamento atual
			 */
			loadData() {
				if (!this.config?.id) {
					this.$router.push({ name: 'launch.management.create.mainData' })
					return
				}

				this.setNextLoad(true)
				launchDay.get('boxes/launchday_id', this.config.id)
					.then(response => {
						this.data = [...response.data]
						this.form = {
							name: '',
							user_id: '',
							launchday_id: this.config.id
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.setNextLoad(false)
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>